import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

class SalesOrderCartItems extends Component {
    displayName = SalesOrderCartItems.name

    render() {
        let showDelete = !this.props.orderSubmitted && !this.props.hasConflicts;

        return (
            <div>
                <table className="table table-hover" id="tab_logic">
                    <tbody>
                        {this.props.salesOrderCart.map((salesOrderItem, idx) => 
                            (<tr key={idx}>                            
                                <td>{salesOrderItem.ogcDescription}</td>
                                <td>{salesOrderItem.qtyToOrder}</td>
                                <td style={{ width: '50px' }} >
                                    {showDelete &&
                                        <React.Fragment>
                                        {!salesOrderItem.locked &&
                                            <button
                                                className="btn btn-outline-danger btn-sm deleteButton"
                                                onClick={this.props.zeroRow(salesOrderItem)}
                                            >
                                                X
                                        </button>
                                        }
                                        </React.Fragment>
                                    }
                                </td>
                            </tr>)
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}

export class SalesOrderCart extends Component {
    displayName = SalesOrderCart.name

    render() {

        var totalQty = 0;
        var totalPrice = 0;
        
        for (var i = 0; i < this.props.salesOrderCart.length; i++) {
            totalQty += parseInt(this.props.salesOrderCart[i].qtyToOrder,10);
            totalPrice += (parseFloat(this.props.salesOrderCart[i].price.replace('$', '')) * parseInt(this.props.salesOrderCart[i].qtyToOrder,10));
        }

        return (
            <div className={this.props.orderSubmitted ? '' : (this.props.currOrder ? '' : 'hideMe')}>
                <Tabs selectedIndex={this.props.tabIndex} onSelect={tabIndex => this.props.setTab(tabIndex)}>
                    <TabList className={this.props.orderSubmitted ? '' : (this.props.currOrder ? '' : 'hideMe')}>
                      
                            <React.Fragment>
                                <Tab style={{ textAlign: 'center', minWidth: '80px' }}>All</Tab>
                                <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Fruit</Tab>
                                <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Veg</Tab>
                                <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Mixes/Mushrooms</Tab>
                                <Tab style={{ textAlign: 'center', minWidth: '80px' }}>Specialties</Tab>
                            </React.Fragment>
                        
                    </TabList>
                    <div className={this.props.orderSubmitted ? 'orderSubmittedBottom' : (this.props.currOrder ? 'scrollContainerSmall' : 'hideMe')}>
                        <TabPanel>
                            <SalesOrderCartItems
                                orderSubmitted={this.props.orderSubmitted}
                                zeroRow={this.props.zeroRow}
                                salesOrderCart={this.props.salesOrderCart}
                                updateRow={this.props.updateRow}
                                hasConflicts={this.props.hasConflicts}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesOrderCartItems
                                orderSubmitted={this.props.orderSubmitted}
                                zeroRow={this.props.zeroRow}
                                salesOrderCart={this.props.salesOrderCart.filter((n) => n.productClass === 'FR')}
                                updateRow={this.props.updateRow}
                                hasConflicts={this.props.hasConflicts}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesOrderCartItems
                                orderSubmitted={this.props.orderSubmitted}
                                zeroRow={this.props.zeroRow}
                                salesOrderCart={this.props.salesOrderCart.filter(function (n) { return n.productClass === 'VE' && ((n.ogcDescription.indexOf("Mushroom") > -1) ? false : true) && ((n.ogcDescription.indexOf("Mix") > -1) ? false : true); })}
                                updateRow={this.props.updateRow}
                                hasConflicts={this.props.hasConflicts}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesOrderCartItems
                                orderSubmitted={this.props.orderSubmitted}
                                zeroRow={this.props.zeroRow}
                                salesOrderCart={this.props.salesOrderCart.filter(function (n) { return n.ogcDescription.indexOf("Mix") > -1 || n.ogcDescription.indexOf("Mushroom") > -1; })}
                                updateRow={this.props.updateRow}
                                hasConflicts={this.props.hasConflicts}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesOrderCartItems
                                orderSubmitted={this.props.orderSubmitted}
                                zeroRow={this.props.zeroRow}
                                salesOrderCart={this.props.salesOrderCart.filter((n) => n.productClass !== 'VE' && n.productClass !== 'FR')}
                                updateRow={this.props.updateRow}
                                hasConflicts={this.props.hasConflicts}
                            />
                        </TabPanel>
                    </div>
                </Tabs>
                {this.props.orderGuideGroup.showTotalOrder &&
                    <div className="footer" style={{ fontSize: '20px', color: 'white', textAlign: 'left' }}>
                        <span style={{ marginRight: '30px' }}>Cases: {totalQty}</span>
                        {this.props.orderGuideGroup.showPricing &&
                            <span>Price: ${totalPrice.toFixed(2)}</span>
                        }
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SalesOrder/SalesOrderCart.js